import { FC } from "react";
import { Box, useTheme } from "@mui/material";
import { Modal, ModalProps } from "@vilocnv/allsetra-core";
import { useTranslation } from "react-i18next";
import { RideHistoryItemDto } from "domain/rides/entities/dtos/ride-history.dto";
import RideHistoryTimeline from "../RideHistoryTimeline";

export type RideHistoryModalProps = Pick<ModalProps, "open" | "onClose"> & {
  items: RideHistoryItemDto[];
  loading?: boolean;
  rideId?: number | string;
};

const RideHistoryModal: FC<RideHistoryModalProps> = ({
  open,
  onClose,
  items,
  loading = false,
  rideId
}) => {
  const theme = useTheme();
  const { t } = useTranslation(["translation"]);

  const title =
    rideId !== undefined && rideId !== ""
      ? `${t("rideHistory.title")} — ${t("common.ride")} № ${rideId}`
      : t("rideHistory.title");

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      primaryBtnProps={{
        text: t("buttonsText.close"),
        onClick: onClose
      }}
      secondaryBtnProps={{
        text: "",
        sx: { display: "none" }
      }}
      theme={theme}
      size="large"
      // The core Modal gives the paper a fixed width per size (large = 900px),
      // which leaves the timeline floating in empty space. `modalStyle` lands
      // on the MUI Modal root, so the paper is reached through its child.
      modalStyle={{
        "& > .MuiBox-root": {
          width: "fit-content",
          minWidth: "420px",
          maxWidth: "min(900px, 92vw)"
        }
      }}
    >
      {/*
        No scroll container here on purpose: the core Modal body already caps
        itself (`maxHeight: 600px`, `overflow-y: scroll`). A second one nests
        two scrollers, and since the inner box can be taller than the space the
        outer one leaves, its last rows stay unreachable.
      */}
      <Box
        data-testid="ride-history-modal"
        sx={{ width: "100%", minHeight: 200 }}
      >
        <RideHistoryTimeline items={items} loading={loading} />
      </Box>
    </Modal>
  );
};

export default RideHistoryModal;
